<template>
    <div class="chat_thread_section">
        <div v-if="!isLoadingRoom" class="chat_item_list">
            <transition-group name="chat_thread_list">
                <thread
                        v-for="thread in fillterThreads"
                        :key="thread.id"
                        :thread="thread"
                        :active="thread.id === currentThread.id"
                        @switch-thread="switchThread(thread.id)">
                </thread>
            </transition-group>
        </div>
        <spinner
                v-if="isLoadingRoom"
                class="chat_loading_room"
                :show="true"
        ></spinner>
    </div>
</template>

<script>
import Thread from './Thread.vue'
import { mapMutations, mapGetters } from 'vuex'
import Spinner from './Spinner'

export default {
  name: 'ThreadSection',
  props: {
    searchThread: String
  },
  components: { Spinner, Thread },
  computed: {
    ...mapGetters(['threads', 'currentThread', 'isLoadingRoom', 'currentThreadID', 'isLoadedInitData']),
    fillterThreads: function () {
      const resultThreads = []
      for (const prop in this.threads) {
        if (this.threads.hasOwnProperty(prop)) {
          if (this.threads[prop].name.toLowerCase().indexOf(this.searchThread.toLowerCase()) !== -1) {
            resultThreads.push(this.threads[prop])
          }
        }
      }
      resultThreads.sort(function (thread1, thread2) {
        if (thread1.lastMessage == null) {
          if (thread2.lastMessage == null) {
            return 0
          } else {
            return 1
          }
        }
        if (thread1.lastMessage !== null) {
          if (thread2.lastMessage == null) {
            return -1
          }
        }

        const time1 = new Date(thread1.lastMessage.time).getTime()
        const time2 = new Date(thread2.lastMessage.time).getTime()
        return time2 - time1
      })
      if (!this.currentThreadID) {
        if (this.isLoadedInitData && resultThreads.length > 0) {
          this.switchThread(resultThreads[0].id)
        }
      }
      return resultThreads
    }
  },
  methods: {
    ...mapMutations(['switchThread'])
  }
}
</script>

<style lang="scss">
.chat_thread_section {
    margin-top: 8px;
    height: calc(100% - 16px);
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    .chat_loading_room {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
}
.chat_thread_list-move {
    transition: transform 0.3s ease;
}
</style>
